import cx from 'classnames';
import type { HTMLAttributes } from 'react';
import css from './Hr.module.scss';

interface IHrProps extends HTMLAttributes<HTMLHRElement> {
  margin?: number;
}

export const Hr = ({ className, margin = 24, ...rest }: IHrProps) => (
  <hr
    className={cx(className, css.hr)}
    style={{
      marginTop: margin,
      marginBottom: margin,
    }}
    {...rest}
  />
);
